import { useGetWhitelabelSitesQuery } from '../api'

interface Props {
  storeConfigurationId?: string
  warehouseId?: string
  type?: string
  whitelabelSiteId?: string
  partnerId: string // For non-admin endpoint, partnerId is required as it needs to be authorized by resource in mesh
  skip?: boolean
}

export const useGetWhitelabelSites = ({
  storeConfigurationId,
  warehouseId,
  type,
  whitelabelSiteId,
  partnerId,
  skip = false,
}: Props) => {
  const { data, error, loading } = useGetWhitelabelSitesQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      storeConfigurationId: storeConfigurationId,
      warehouseId: warehouseId,
      type: type,
      whitelabelSiteId: whitelabelSiteId,
      partnerId: partnerId,
    },
    skip: skip,
  })

  return {
    apiResult: data?.onboardingServiceGetWhitelabelSites?.whitelabelSites,
    apiSuccess: !error,
    apiLoading: loading,
    apiError: error,
  }
}
